import {
  Button,
  Column,
  Heading,
  Row,
  Stack,
} from '@grubhubprod/gh-cookbook-react/dist';
import React from 'react';
import { PageSection } from 'src/components/selfService/layout/PageSection/PageSection';
import { PageSectionTitle } from 'src/components/selfService/layout/PageSectionTitle/PageSectionTitle';
import { useScreenSizes } from 'src/utilities/useScreenSizes';
import { ICorp } from 'src/components/Account/Account';

export interface AccountCorporateSectionProps {
  corp: ICorp;
  onEditClick: () => void;
}

function getAddress(corp: ICorp) {
  return `${corp.location.address}, ${corp.location.city}, ${corp.location.state} ${corp.location.zip} `;
}

function getAdminInfo(corp: ICorp) {
  return `${corp.adminInfo.first_name} ${corp.adminInfo.last_name}   ${corp.adminInfo.email}`;
}

export const AccountCorporateSection: React.FC<AccountCorporateSectionProps> =
  ({ corp, onEditClick }) => {
    const { isPhone, isDesktop } = useScreenSizes();

    return (
      <PageSection dataTestId="account-corporate-section">
        <PageSectionTitle title={corp.name} />
        <Stack y="sm">
          <Row gutter={0}>
            <Column gutter={0} phone={12}>
              <Heading variant="h5">Admin</Heading>
              <p>{getAdminInfo(corp)}</p>
            </Column>
          </Row>
        </Stack>
        <Stack y="sm">
          <Row gutter={0}>
            <Column gutter={0} phone={12} tablet={5} desktop={4}>
              <Stack x={isPhone ? 'none' : 'sm'} y={!isDesktop ? 'sm' : 'none'}>
                <Heading variant="h5">Address</Heading>
                <p>{getAddress(corp)}</p>
              </Stack>
            </Column>
            <Column gutter={0} phone={12} tablet={4} desktop={5}>
              <Stack y={!isDesktop ? 'sm' : 'none'}>
                <Heading variant="h5">Phone</Heading>
                <p>{corp.location.phone}</p>
              </Stack>
            </Column>
            <Column gutter={0} phone={12} tablet={3} desktop={3}>
              <Button
                variant="secondary"
                buttonSize="medium"
                block
                onClick={onEditClick}
              >
                Edit
              </Button>
            </Column>
          </Row>
        </Stack>
      </PageSection>
    );
  };
